module.exports = require("./../../_gen/starling/events/Touch");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/events/Touch.js
// module id = 184
// module chunks = 0